import React from 'react';
import { FieldArray, getFormValues } from 'redux-form';
import { connect } from 'react-redux';
import ItemVariantsFieldArray from './ItemVariantsFieldArray';
import SalesTypeItemVariantsFieldArray from './SalesTypeItemVariantsFieldArray';

class ItemVariants extends React.Component {
  render() {
    const {
      item: { is_sales_type_price: isSalesTypePrice },
    } = this.props;
    const defaultValue = { price: undefined, sku: undefined };
    const pricingTypeObj = { isSalesTypePrice };
    return (
      <div>
        <FieldArray
          name="item_variants"
          component={ItemVariantsFieldArray}
          defaultValue={defaultValue}
          placeholder="price"
          props={pricingTypeObj}
        />
        {isSalesTypePrice && (
          <FieldArray
            name="sales_type"
            component={SalesTypeItemVariantsFieldArray}
            defaultValue={defaultValue}
            placeholder="sales type"
          />
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    item: getFormValues('itemHub')(state),
  };
}

export default connect(mapStateToProps)(ItemVariants);
